import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import edit_stl_svg from '../../../assets/img/SVG_icons/Top/reference_operation/edit_reference.svg';
import { img } from '@phi/components';
import { edit_reference_stl_body } from '@frontend/scene';
import EditSTLTooltip from './EditSTLTooltip';

export const EditSTLIcon = edit_stl_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Edit reference STL models';
        },

        disabled() {
            return !this.state.loaded
                || this.state.framework !== 'onshape'
                || !this.state.showing_reference_stl;
        }
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                edit_reference_stl_body();
        }
    },

    render() {
        return h(BarButton, {
            tippy: 'top',
            id: 'edit-stl-button',
            active: this.state.editing_reference_stl,
            disabled: this.disabled,
            onClick: this.onClick,
            selected: this.state.tut_stage === 13,
            help: 'edit_stl_reference_model',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(edit_stl_svg, this.alt),
            tooltip: EditSTLTooltip,
        });
    },
});
